import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import DrawerAddCampaignStep1 from '~/pages/cp/campaigns/add/drawerAddCampaignStep1'
import { alterSiteDrawer } from '~/data/actions/siteActions'

export default function SmsWelcome({ refresh = () => {} }) {
    const dispatch = useDispatch()
    const history = useHistory()
    const site = useSelector((state) => state.siteMaster)

    const createCampaign = () => {
        const content = <DrawerAddCampaignStep1 campaignType={6} history={history} />
        dispatch(alterSiteDrawer(true, false, 'right', content, true, 500, 'drawer_nopad'))
    }

    return (
        <>
            <Paper className='paper-dotted'>
                <div className='quickFlex' style={{ gap: 40, alignItems: 'center' }}>
                    <img
                        className='hide-xs'
                        src='https://cdn1.ourmailsender.com/siteContent/noneholdersnew/sms-none.png'
                        style={{ borderRadius: '12px' }}
                    />

                    <div style={{ flexGrow: 1, maxWidth: 640 }}>
                        <Icons
                            outerStyle={{ display: 'inline-flex', marginBottom: 24 }}
                            circle={true}
                            color={site.colours['$primary']}
                            icon='sms'
                        />
                        <h2 style={{ marginBottom: 8 }}>Add SMS to your marketing toolkit</h2>
                        <div style={{ color: 'var(--neutral-800)', marginBottom: 24 }}>
                            Reach customers instantly with SMS campaigns. Schedule messages, personalise content, and
                            track results — just like you do with email.
                        </div>
                        <div className='quickFlex' style={{ gap: 10, marginBottom: 24 }}>
                            <Button
                                onClick={createCampaign}
                                className='button-primary'
                                iconLeft={<Icons icon='plus' />}
                                postHogTag='sms-sms-settings-create'
                            >
                                Create your first SMS Campaign
                            </Button>
                            <Button
                                className='button-lightGrey'
                                iconRight={
                                    <Icons
                                        icon='external'
                                        colour={'var(--neutral-950)'}
                                        style={{ height: 16, width: 16 }}
                                    />
                                }
                                href='https://transpond.io/support/creating-and-sending-campaigns/sms-campaigns-uk-only'
                                target='_blank'
                                postHogTag='sms-sms-settings-learn-more'
                            >
                                Learn More
                            </Button>
                        </div>
                        <div className='text-xsml' style={{ color: 'var(--neutral-700)' }}>
                            Only available for UK customers
                        </div>
                    </div>
                </div>
            </Paper>
        </>
    )
}
